import React from 'react';

export default class Redirect extends React.Component {
  constructor(props) {
    super(props);
    this.url = props.url;
  }

  render() {
    // eslint-disable-next-line
    return (window.location.href = this.url);
  }
}
